var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlarmNoalarmEcho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_alarm_noalarm_echo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_alarm_noalarm_echo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    stroke: "#009527",
    fill: "#FFFFFF",
    cx: 7,
    cy: 7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16949153,7.26440678 L10.7016949,7.26440678 C10.7220339,7.20338983 10.7322034,7.13220339 10.7322034,7 C10.7322034,5.04745763 9.43050847,4 7.42711864,4 C5.28135593,4 4,5.15932203 4,7.01016949 C4,8.84067797 5.28135593,10 7.50847458,10 C8.81016949,10 9.77627119,9.68474576 10.5389831,9.00338983 L9.84745763,8.26101695 C9.23728814,8.8 8.59661017,9.06440678 7.56949153,9.06440678 C6.16610169,9.06440678 5.28135593,8.47457627 5.16949153,7.26440678 Z M7.43728814,4.93559322 C8.53559322,4.93559322 9.32881356,5.39322034 9.58305085,6.41016949 L5.22033898,6.42033898 C5.4440678,5.43389831 6.26779661,4.93559322 7.43728814,4.93559322 Z",
    id: "e-copy-2",
    fill: "#009527",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmNoalarmEcho);
export default __webpack_public_path__ + "static/media/icon_alarm_noalarm_echo.f2d3a64ca47315a60821a147f8bdb921.svg";
export { ForwardRef as ReactComponent };